import { render, staticRenderFns } from "./cloud.vue?vue&type=template&id=33539eaa&"
import script from "./cloud.vue?vue&type=script&lang=js&"
export * from "./cloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContentType4: require('D:/Project/kpwebsite/PC/components/content/content-type-4.vue').default})
